import { isEmpty } from "./isEmpty"

type ConvertToLocaleParams = {
  amount: number
  currency_code: string
  minimumFractionDigits?: number
  maximumFractionDigits?: number
  locale?: string
}

export const convertToLocale = ({
  amount,
  currency_code,
  minimumFractionDigits,
  maximumFractionDigits,
  locale = "en-US",
}: ConvertToLocaleParams) => {
  return currency_code && !isEmpty(currency_code)
    ? new Intl.NumberFormat(locale, {
        style: "currency",
        currencyDisplay: "symbol",
        currency: currency_code,
        minimumFractionDigits,
        maximumFractionDigits,
      }).format(amount)
    : amount.toString()
}

/**
 * Format a major-unit amount - the unit Medusa stores prices in and the
 * pricing module reports - for display. Nothing is rescaled here on purpose:
 * this function used to divide by 100 because the seed data held cents, and
 * the data has since been migrated to major units. Re-adding a scale factor
 * is how a 100x pricing bug comes back.
 */
export const formatAmount = ({
  amount,
  currency_code,
  locale,
}: {
  amount: number
  currency_code: string
  locale?: string
}) => convertToLocale({ amount, currency_code, locale })
